import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, TextField, MenuItem, Button } from "@material-ui/core";

import Loading from "../../loading";
import TableFormat from "../../../partials/TableFormat";
import FilterList from "../../../partials/filterList";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
// import EditCard from "./edit";
const headCells = [
  {
    key: "to",
    numeric: false,
    disablePadding: false,
    label: "sms_manage_title_to",
  },
  {
    key: "message",
    numeric: false,
    disablePadding: false,
    label: "sms_manage_title_message",
  },
  {
    key: "status",
    numeric: false,
    disablePadding: false,
    label: "sms_manage_title_status",
  },
];
const listStatus = [
  {
    value: "sending",
    label: "sms_manage_sms_status_sending",
    color: "rgb(225, 210, 36)",
  },
  {
    value: "fail",
    label: "sms_manage_sms_status_fail",
    color: "rgb(208, 53, 53)",
  },
  {
    value: "finish",
    label: "sms_manage_sms_status_finish",
    color: "rgb(130, 193, 77)",
  },
];

class SMSManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: [],
      status: -1,
      listFilter: {
        status: ""
      },
    };
  }
  componentDidMount() {
    this.props.onRef(this)
    this.getListSMS();
  }
  openSendSMS = () => {
    this.props.history.push("/sms/send");
  };
  handleCheckBoxToolbar = async (e) => {
    let data = {
      sendSMSByMasspa: e.target.checked ? 1 : 0
    }
    await this.props.updateServiceSetting({ data: data })
    await this.props.getServiceSetting()
  }
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  checkListFilter = () => {
    let { status, listFilter } = this.state;
    listFilter["status"] = listStatus.find(item => item.value === status);
    listFilter["status"] = listFilter["status"] ? listFilter["status"].label : "";
    this.setState({ listFilter })
  }
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        status: -1,
        arrange_date: {},
        listFilter: {
          status: ""
        },
      },
      function () {
        let { page, rowsPerPage } = this.mTable.state;
        let { search } = _this.state;
        let filter_exact = [];
        _this.props.getListForSMS({
          page: page,
          limit: rowsPerPage,
          filter_exact: filter_exact,
          search: search,
        });
      }
    );
  };
  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  };
  getListSMS = async (payload) => {
    this.loading.startLoading();
    await this.props.getList(payload);
    this.loading.stopLoading();
  };
  renderStatus = (itemSMS) => {
    const { classes, t } = this.props;
    return listStatus.map((item, index) => {
      if (item.value === itemSMS.status)
        return (
          <Button
            key={index}
            classes={{
              root: classes.btnStatus,
            }}
            size="small"
            style={{ backgroundColor: item.color, color: "#fff" }}
          >
            {t(item.label)}
          </Button>
        );
    });
  };
  render() {
    const { t, listSMS, serviceSetting, total, count, classes } = this.props;
    const { collapse = [], status, listFilter } = this.state;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <FilterList
          onRef={(id) => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.props.getListForSMS}
        >
          <Grid item xs={12} sm={12}>
            <TextField
              select
              label={t("sms_manage_title_status")}
              placeholder={t("pls_select")}
              fullWidth
              className={classes.textField}
              value={status}
              onChange={this.handleChange}
              name="status"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              margin="normal"
              variant="outlined"
            >
              <MenuItem value={-1}>
                {t("sms_listsms_show_all")}
              </MenuItem>
              {listStatus.map((item, index) => {
                return (
                  <MenuItem
                    key={`status-item-${index}`}
                    value={item.value}
                  >
                    {t(item.label)}
                  </MenuItem>
                )
              })}
              {/* <MenuItem value="sending">{t("sms_manage_sms_status_sending")}</MenuItem>
              <MenuItem value="finish">{t("sms_manage_sms_status_finish")}</MenuItem>
              <MenuItem value="fail">{t("sms_manage_sms_status_fail")}</MenuItem> */}
            </TextField>
          </Grid>
        </FilterList>
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          title={t("sms_tag_sms_manage")}
          showActionToolbar={true}
          titleActionToolbar={t("sms_send_sms")}
          actionToolbar={this.openSendSMS}
          showCheckBoxToolbar={true}
          titleCheckBoxToolbar={t("sms_send_sms_by_masspa_device")}
          actionCheckBoxToolbar={this.handleCheckBoxToolbar}
          nameCheckBoxToolbar="smsByMasspa"
          valueCheckBoxToolbar={serviceSetting.sendSMSByMasspa}
          showFilter={true}
          openFilter={(e) => this.showFilter(e)}
          listFilter={listFilter}
          totalCount={total}
          count={count}
          headCells={headCells}
          size={"medium"}
          collapse={collapse}
          isCollapse={false}
          hiddenSearch={false}
          placeholder={t("sms_search_by_to_phone_number")}
          showCheckBox={false}
          showFilterBranch={false}
          getList={this.getListSMS}
          rows={listSMS.map((row, index) => {
            return {
              id: row.code,
              to: row.to,
              message: row.message,
              status: this.renderStatus(row)
            };
          })}
        />
      </React.Fragment>
    );
  }
}

SMSManage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listSMS: state.sms.listSMS,
  total: state.sms.total,
  count: state.sms.count,
  serviceSetting: state.serviceSetting.serviceSetting,
});
const mapDispatch = (dispatch) => ({
  getList: dispatch.sms.getList,
  updateServiceSetting: dispatch.serviceSetting.updateServiceSetting,
  getServiceSetting: dispatch.serviceSetting.getServiceSetting,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(SMSManage)
  )
);
